import { render, staticRenderFns } from "./CreateNewMessageDialog.vue?vue&type=template&id=4b85ad02"
import script from "./CreateNewMessageDialog.vue?vue&type=script&lang=js"
export * from "./CreateNewMessageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports